module.exports = __webpack_public_path__ + "static/cv_ricardo_garcia_silva-4efb504a71c13a371ac986ebe293849b.pdf";